const { connect } = require('react-redux');
const BrokerCustomWalletCreate = require ('./brokerCustomWalletCreate');
// @ actions
const actions = require('../../actions/brokerCustomWalletEditablePortfolio.js');
const portfolios = require('../../actions/brokerCustomWalletPortfolios.js');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');

module.exports.BrokerCustomWalletCreate = connect(
    state => ({
        immBrokerCustomWalletEditablePortfolio: state.brokerCustomWalletEditablePortfolio,
    }),
    {
        init: actions.init,
        getContractsList: actions.getContractsList,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        cancelEdition: portfolios.cancelEdition,
    }
)(BrokerCustomWalletCreate);
